namespace RioERP.Orders {
    export interface CounterOrdersForm {
        CustomerId: Serenity.LookupEditor;
        CustomerName1: Serenity.StringEditor;
        CustomerEmail1: Serenity.StringEditor;
        CustomerEmail2: Serenity.StringEditor;
        CustomerMobile11: Serenity.StringEditor;
        CustomerMobile21: Serenity.StringEditor;
        StudentImage: Serenity.ImageUploadEditor;
        BillingAddress1: Serenity.StringEditor;
        BillingAddress2: Serenity.StringEditor;
        BillingCity: Serenity.StringEditor;
        BillingStateId: Serenity.LookupEditor;
        BillingPincode: Serenity.IntegerEditor;
        ProductId: Serenity.LookupEditor;
        DiscountAmount: Serenity.DecimalEditor;
        OrderProductSpecificationId: Serenity.LookupEditor;
        ShippingToName: Serenity.StringEditor;
        ShippingAddress1: Serenity.StringEditor;
        ShippingAddress2: Serenity.StringEditor;
        ShippingCity: Serenity.StringEditor;
        ShippingStateId: Serenity.LookupEditor;
        ShippingPincode: Serenity.IntegerEditor;
        EOrderStatus: Serenity.EnumEditor;
        ESourceType: Serenity.EnumEditor;
        GrossAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        EPaymentStatus: Serenity.EnumEditor;
        EPaymentType: Serenity.EnumEditor;
        Gstin: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.IntegerEditor;
        ShippingNote: Serenity.StringEditor;
        Note: Serenity.StringEditor;
    }

    export class CounterOrdersForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.CounterOrders';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CounterOrdersForm.init)  {
                CounterOrdersForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.ImageUploadEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.EnumEditor;

                Q.initFormType(CounterOrdersForm, [
                    'CustomerId', w0,
                    'CustomerName1', w1,
                    'CustomerEmail1', w1,
                    'CustomerEmail2', w1,
                    'CustomerMobile11', w1,
                    'CustomerMobile21', w1,
                    'StudentImage', w2,
                    'BillingAddress1', w1,
                    'BillingAddress2', w1,
                    'BillingCity', w1,
                    'BillingStateId', w0,
                    'BillingPincode', w3,
                    'ProductId', w0,
                    'DiscountAmount', w4,
                    'OrderProductSpecificationId', w0,
                    'ShippingToName', w1,
                    'ShippingAddress1', w1,
                    'ShippingAddress2', w1,
                    'ShippingCity', w1,
                    'ShippingStateId', w0,
                    'ShippingPincode', w3,
                    'EOrderStatus', w5,
                    'ESourceType', w5,
                    'GrossAmount', w4,
                    'NetAmount', w4,
                    'TaxableAmount', w4,
                    'TaxAmount', w4,
                    'EPaymentStatus', w5,
                    'EPaymentType', w5,
                    'Gstin', w1,
                    'InvoiceCompanyId', w3,
                    'ShippingNote', w1,
                    'Note', w1
                ]);
            }
        }
    }
}
